module.exports = __webpack_public_path__ + "img/gallery-9.3a327b04.png";